import { apiHandlerWithError } from '../apiHandler';

const signOut = async () => {
  return await apiHandlerWithError.delete('sessions');
};

export default signOut;
